import { Image, PartScrollPos } from "nystem-components";
import React from "react";
import "./frontlogo.css";

const PartFrontlogo = () => (
  <PartScrollPos>
    {({ scrollTop }) => (
      <div className="center-first" style={{ bottom: scrollTop, "--logo-scroll": `${scrollTop}px` }}>
        <div className="front-logo-box">
          <Image src="/image/150x200/logo.png" className="w-full h-full" alt="Logo" />
        </div>
      </div>
    )}
  </PartScrollPos>
);

export default PartFrontlogo;
